import React from 'react';
import { Autocomplete, Button, MenuItem, styled, TextField } from '@mui/material';
import Dialog from 'components/dialogs/Dialog';
import { SupplierBank } from 'types/supplier';
import { Bank } from 'types/bank';

interface SupplierBankFormProps {
  banks: Bank[];
  onExited: () => void;
  handleAddBank: (bankInfo: SupplierBank | null) => void;
  bankInfo: SupplierBank | null;
  handleChangeBankInfo(index: keyof SupplierBank, value: any): void;
  type: 'new' | 'edit';
}

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  columnGap: 10,
  rowGap: 15,
});

const DialogActions = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
});

const SupplierBankForm: React.FC<SupplierBankFormProps> = ({
  handleAddBank,
  onExited,
  banks,
  bankInfo,
  handleChangeBankInfo,
  type,
}) => {
  return (
    <Dialog
      onExited={onExited}
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth="sm"
      height="auto"
      title={type === 'edit' ? 'Editar conta bancária' : 'Adicionar conta bancária'}
    >
      <Container>
        <Autocomplete
          value={bankInfo?.bank_name || ''}
          options={banks.map(bank => bank.name)}
          getOptionLabel={option => option}
          onChange={(event, newValue) => {
            handleChangeBankInfo('bank_name', newValue || '');
          }}
          renderInput={params => <TextField {...params} label="Banco" placeholder="Selecione um banco" fullWidth />}
        />

        <TextField
          label="Titular"
          placeholder="Digite o nome do titular"
          value={bankInfo?.account_holder || ''}
          onChange={e => handleChangeBankInfo('account_holder', e.target.value)}
          fullWidth
        />

        <TextField
          label="Agência"
          placeholder="Digite o número da agência"
          value={bankInfo?.bank_agency || ''}
          onChange={e => handleChangeBankInfo('bank_agency', e.target.value)}
          fullWidth
        />

        <TextField
          label="Conta"
          placeholder="Digite o número da conta"
          value={bankInfo?.bank_account || ''}
          onChange={e => handleChangeBankInfo('bank_account', e.target.value)}
          fullWidth
        />

        <TextField
          select
          label="Tipo chave PIX"
          placeholder="Selecione o tipo da chave PIX"
          value={bankInfo?.pix_key_type || ''}
          onChange={e => handleChangeBankInfo('pix_key_type', e.target.value)}
          fullWidth
        >
          <MenuItem value="cpf">CPF</MenuItem>
          <MenuItem value="cnpj">CNPJ</MenuItem>
          <MenuItem value="email">Email</MenuItem>
          <MenuItem value="phone">Telefone</MenuItem>
          <MenuItem value="random">Aleatório</MenuItem>
        </TextField>

        <TextField
          label="Chave PIX"
          placeholder="Digite a chave PIX"
          value={bankInfo?.pix_key || ''}
          onChange={e => handleChangeBankInfo('pix_key', e.target.value)}
          fullWidth
        />

        <TextField
          label="Operação"
          placeholder="Digite o tipo de operação"
          value={bankInfo?.operation || ''}
          onChange={e => handleChangeBankInfo('operation', e.target.value)}
          fullWidth
        />

        <DialogActions>
          <Button variant="outlined" color="primary" onClick={onExited}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={() => handleAddBank(bankInfo)}>
            {type === 'new' ? 'Adicionar' : 'Salvar'}
          </Button>
        </DialogActions>
      </Container>
    </Dialog>
  );
};

export default SupplierBankForm;
